import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { flexbox, layout, space, system, typography } from 'styled-system';
const StyledIcon = styled.i.withConfig({
  displayName: "StyledIcon",
  componentId: "sc-1kfdbqj-0"
})(["&&&{", " ", " ", " ", " cursor:", ";", "}"], space, typography, flexbox, layout, props => props.isPointer ? 'pointer' : 'auto', system({
  color: {
    properties: ['stroke', 'fill'],
    scale: 'colors'
  }
}));
export const Icon = React.forwardRef(function Icon(props, ref) {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return React.createElement(StyledIcon, _extends({
    ref: ref
  }, rest), React.Children.only(children));
});
Icon.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
}, propTypes.space), propTypes.typography), propTypes.flexbox), propTypes.layout) : {};
Icon.defaultProps = {
  color: 'brandDark',
  fontSize: 'inherit'
};